export interface SuscripcionCampoAdicionalVista {
    intIdSuscripcionCampoAdicional: number;
    uniIdSuscripcionCampoAdicional: string;
    sinCodSuscripcionCampoAdicionalEntidad: number;
    tinCodSuscripcionCampoAdicionalTipo: number;
    vchLabel: string;
    vchNombre: string;
    bitRequerido: boolean;
    sinOrden: number;
    bitActivo: boolean;
    vchOpciones?: string;
}

export interface OrdenCampoAdicionalValorDTO {
    uniIdSuscripcionCampoAdicional: string;
    vchValor: string | null;
}

export const TIPO_CAMPO_ADICIONAL = {
    TEXTO: 1,
    AREA_TEXTO: 2,
    CHECKBOX: 3,
    SELECTOR: 4,
} as const;
